import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-developer-tools',
  templateUrl: './developer-tools.component.html',
  styleUrls: ['./developer-tools.component.css']
})
export class DeveloperToolsComponent implements OnInit {

  @Input() errorLog: {timeStamp: Date, log: string}[] = [];

  @Output() log = new EventEmitter();

  showLog = false;

  constructor() { }

  ngOnInit() {
  }

  onLog() {
    this.showLog = !this.showLog;
    const link = document.getElementById('downloadFile');
    this.log.emit(link);
  }

}
